import './loginPage.scss';

import { CircularProgress } from 'material-ui';
import { MuiThemeProvider } from 'material-ui/styles';
import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { Control, Form } from 'react-redux-form';
import { withRouter } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import { IHistory } from 'src/interfaces';

import { setLoading, setSuccess } from '../../actions/loadingActions';
import { EMPTY_FIELD_MESSAGE } from '../../constants/generals';
import { loginUser, checkForUserExpiry } from '../../services/loginService';
import { isFormEmpty } from '../../utils/generalUtils';
import { Async } from '../reusableComponents/Async'; 
declare var require: any;
const logo = require('../../images/logo.png');
const bgImage = require('../../images/bg.jpg');

export interface ILoginPageProps extends DispatchProp<any> {
    history: IHistory;
    pathName: string;
    isLoggedIn: boolean;
    expiryCheck: boolean;
}

export class LoginPageImpl extends React.PureComponent<ILoginPageProps, {}> {
    constructor(props: ILoginPageProps) {
        super(props);
    }

    componentDidMount() {

        if (this.props.isLoggedIn) {
            this.props.history.push('/home');
        }
        document.title = 'Login To Argos';
    }

    handleSubmit = (values) => {
        const { pathName, history } = this.props;
        setLoading('LoginButton');
        if (isFormEmpty(values)) {
            toast.error(EMPTY_FIELD_MESSAGE, {
                position: toast.POSITION.TOP_CENTER,
                className: 'failed-toast'
            });
            setSuccess('LoginButton');
            return;
        }
        loginUser(values.UserId as Number, values.Password, this.props.history, pathName);
    }

    render() {
        return [
            <ToastContainer key={0} />,
            <img key={1} src={bgImage} className="background" height="300" width="300" />,
            <div key={2} className="dark-theme" />,
            <div key={3} className="login-page" >
                <div className="left-section" >
                    <h1>
                        <img src={logo} />
                        <br />
                        Welcome To <br />
                        Argos EMS <br />
                        System
                    </h1>
                </div>
                <div className="right-section" >
                    <h1 className="login-text" >
                        Login to Argos
                    </h1>
                    <div className="form-section" >
                        <Form model="forms.loginForm" onSubmit={this.handleSubmit} >
                            <div className="control-container" >
                                <Control.text
                                    model=".UserId"
                                    className="login-input"
                                    placeholder="Username"
                                    type="text"
                                />

                            </div>
                            <div className="control-container" >
                                <Control.text
                                    model=".Password"
                                    className="login-input"
                                    placeholder="Password"
                                    type="password"
                                />
                            </div>
                            <Async
                                identifier="LoginButton"
                                promise={() => setSuccess('LoginButton')}
                                error={
                                    <div className="button-container" >
                                        <button className="login-button" >
                                            Login
                                </button>
                                    </div>
                                }
                                loader={
                                    <div className="button-container" >
                                        <button className="login-button-loading" >
                                            <MuiThemeProvider>
                                                <CircularProgress thickness={5} color="#a4bf43" />
                                            </MuiThemeProvider>

                                        </button>
                                    </div>
                                }
                                content={<div className="button-container" >
                                    <button className="login-button" >
                                        Login
                            </button>

                                </div>}
                            />
                        </Form>
                    </div>
                </div>
            </div>
        ];
    }
}

export function mapStateToProps(state, ownProps) {
    let pathName = '/home';

    if (ownProps.location.search) {
        pathName = ownProps.location.search.split('=')[1];
    }
    return {
        isLoggedIn: state.login ? state.login.get('isLoggedIn') : false,
        pathName
    };
}
export const LoginPage = withRouter(connect(mapStateToProps)(LoginPageImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LoginPage/index.tsx